import { render } from "./instore.vue?vue&type=template&id=3d38b9bc"
import script from "./instore.vue?vue&type=script&lang=js"
export * from "./instore.vue?vue&type=script&lang=js"

import "./instore.vue?vue&type=style&index=0&id=3d38b9bc&lang=less"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__